module.exports = __webpack_public_path__ + "static/media/Recetario_comprimido 2MB.89bd8d6f.pdf";